import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputBase from '@mui/material/InputBase'
import InputLabel from '@mui/material/InputLabel'
import get from 'lodash/get'
import Image from 'next/image'
import React, { RefCallback } from 'react'
import { Control, Controller } from 'react-hook-form'
import { IMaskInput } from 'react-imask'
import flagImg from 'src/assets/flag.png'
import { TypoContainer } from 'src/components/StyledTypo'
import { CustomModalTypo } from './StyledTypo'

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

const TextMaskCustom = React.forwardRef<HTMLElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props
    return (
      <IMaskInput
        {...other}
        mask="(#00) 000-0000"
        definitions={{
          '#': /[1-9]/,
        }}
        inputRef={ref as RefCallback<HTMLTextAreaElement | HTMLInputElement>}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        onChange={() => {}}
        overwrite
      />
    )
  }
)

interface PropTypes {
  errors: any
  control: Control<any>
  label: string
  name: string
  placeholder: string
  fullWidth?: boolean
}

export default function PhoneInput({
  errors,
  control,
  label,
  name,
  placeholder,
  fullWidth = true,
}: PropTypes) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <Box className="w-full">
          <CustomModalTypo
            ta={'left'}
            fs={'12px'}
            m={'0px'}
            fw={400}
            lh={'20px'}
            w={'100%'}>
            {label}
          </CustomModalTypo>
          {/* <CustomTypo fs={14} sx={{ mb: 0.5 }}>
            {label}
          </CustomTypo> */}
          <FormControl
            variant="outlined"
            sx={{
              borderRadius: '5px !important',
              border: `1px solid
              ${get(errors, name) ? 'red' : '#E6E6E6E6'}`
            }}
            fullWidth={fullWidth}
            error={Boolean(get(errors, name))}>
            <InputBase
              sx={{
                px: 1.5,
                py: '11.4px',
                borderRadius: '5px'
              }}
              className="bg-white"
              value={value}
              placeholder={placeholder}
              onChange={onChange}
              startAdornment={
                <span className="text-[grey] pr-4 flex">
                  <TypoContainer>
                    <Image
                      src={flagImg}
                      className="h-[20px] w-auto mr-1 object-contain"
                      alt="flag"
                    />
                  </TypoContainer>
                  {'+1'}
                </span>
              }
              inputComponent={TextMaskCustom as any}
            />
          </FormControl>
          {get(errors, `${name}.message`, '') && (
            <InputLabel
              sx={{ color: '#D32F2F', fontSize: '12px', mt: '4px' }}>{`${get(
              errors,
              `${name}.message`
            )}`}</InputLabel>
          )}
        </Box>
      )}
    />
  )
}
